"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StubMessenger = void 0;
class StubMessenger {
    constructor() {
        this.messages = [];
    }
    async send(message) {
        this.messages.unshift(message);
    }
    lastMessage(addr) {
        return this.messages.find(({ recipient }) => recipient === addr) || null;
    }
}
exports.StubMessenger = StubMessenger;
//# sourceMappingURL=messenger.js.map